module.exports = __webpack_public_path__ + "media/images/icon__predict@2x-8a3e574fe924cc1d679d467abd025cdf.png";